module.exports = __webpack_public_path__ + "media/images/emblems/Meilen-blazon-3ee63269bf4004fd59f97909236e7760.svg";